// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"776":"a4c14725","9412":"37a763b4"}[chunkId] || chunkId) + "." + {"776":"3386fb6d80c0d06f","7010":"e5fb31fc8f1cc83d","9412":"6060fcf263750c44"}[chunkId] + ".js";
};